import { inFrame, topmostWindowFrame } from './utils'
import Logger from './Log'

const Log = Logger.for('AdSlot')

export default class AdSlot {
  constructor (targetNode, id, idx) {
    const nodeId = 'smrtb-ad-node-' + id + '-' + idx
    const containerId = 'smrtb-ad-container-' + id + '-' + idx
    const frame = topmostWindowFrame()

    this._targetNode = targetNode

    const oldContainer = frame.document.querySelector('#' + containerId)
    if (oldContainer) {
      Log.debug('Purging old ad container')
      oldContainer.parentElement.removeChild(oldContainer)
    }

    this._node = document.createElement('div')
    this._instanceIdx = idx
    this._container = document.createElement('div')
    this._node.id = nodeId
    this._container.id = containerId
    this._container.class = 'smrtb-ad-container'
    this._parentIsTarget = null
    this._destroyCbs = []
    this._resources = []

    this.resetNode()
    this._container.appendChild(this._node)
  }

  /**
   * This is the target of the container selector for e.g. overlay ads
   * This is not the dom node that contains our ad unit node!
   * @returns {*}
   */
  targetNode () {
    return this._targetNode
  }

  /**
   * Returns the instance index of the tag this slot belongs to. E.g.
   * if the same zoneId tag is on the site three times (like infinite scroll)
   * and this is the third instance, it will return 2
   * @returns {number}
   */
  instanceIdx () {
    return this._instanceIdx
  }

  /**
   * The containing div element that wraps the node div.
   * This node is used to attach buttons, position it, etc
   * @returns {HTMLDivElement}
   */
  container () {
    return this._container
  }

  containerId () {
    return this._container.id
  }

  /**
   * Returns true if we attach our container node to the target node (for example
   * we are given a target ad div) else we attach to document.body.
   * @returns {null}
   */
  parentIsTarget () {
    return this._parentIsTarget
  }

  /**
   * The dom node the ad content should be written into. Placed inside of
   * the container.
   * @returns {HTMLDivElement}
   */
  node () {
    return this._node
  }

  resetNode () {
    this._node.innerHTML = ''
    this._resources.forEach(r => {
      if ('remove' in r) {
        r.remove()
        Log.debug('Removed tracked node resource from page')
      } else {
        Log.warn('Node resource didnt appear to be html element: ' + r)
      }

      this._resources = []
    })
  }

  nodeChildCount () {
    return this._node.childNodes.length
  }

  nodeIsEmpty () {
    return this.nodeChildCount() === 0
  }

  nodeId () {
    return this._node.id
  }

  onDestroy (cb) {
    this._destroyCbs.push(cb)
  }

  resource (r) {
    this._resources.push(r)
  }

  attach (parentIsTarget) {
    this._parentIsTarget = parentIsTarget

    console.log(this._targetNode)

    if (parentIsTarget) {
      const target = this._targetNode

      // Dont append into scripts, or page paragraph content - put after
      if (target.tagName !== 'SCRIPT' && target.tagName !== 'IFRAME' && target.tagName !== 'P') {
        if (target.childNodes.length === 0) {
          target.appendChild(this._container)
          Log.debug('Target appendChild')
        } else {
          target.insertBefore(this._container, target.firstChild)
          Log.debug('Target insertBefore')
        }
      } else {
        Log.debug('Target insertBefore (after) script')
        target.parentElement.insertBefore(this._container, target.nextSibling)
      }
    } else {
      const frame = inFrame()
      if (frame.inFrame) {
        if (!frame.crossDomain) {
          window.top.document.body.appendChild(this._container)
          Log.debug('Found was in frame, appending to top body')
        } else {
          Log.warn('In cross domain frame, must append to current body. May cause style issues')
          document.body.appendChild(this._container)
        }
      } else {
        Log.debug('Appending to doc body')
        document.body.appendChild(this._container)
      }
    }
  }

  destroy () {
    this._container.parentElement.removeChild(this._container)

    this._destroyCbs.forEach(cb => cb())
  }
}
